import { createBrowserRouter } from 'react-router-dom';
import Login from '../pages/auth/login/Login';
import ForgotPassword from '../pages/auth/forgotpassword/ForgotPassword';
import Signup from '../pages/auth/signup/Signup';
import CreateNewPassword from '../pages/auth/createNewPassword/CreateNewPassword';
import OTPVerify from '../pages/auth/otpVerify/OTPVerify';
import Layout from '../layout/Layout';
import Dashboard from '../pages/dashboard';
import OrganizationDetail from '../pages/organizationDetail/OrganizationDetail';
import PrivateRoute from './PrivateRoutes';
import ProductDetails from '../pages/inventory/product';
import ProductGroup from '../pages/inventory/product/productGroup/ProductGroup';
import Adjustment from '../pages/inventory/adjustment';
import InventoryAdjustment from '../pages/inventory/adjustment/InventoryAdjustment';
import NotFound from '../pages/404NotFound';
import CreateProduct from '../pages/inventory/product/addProduct/CreateProduct';
import GroupDetails from '../pages/inventory/product/productGroup/GroupDetails';
import Vendors from '../pages/vendors/Vendors';
import CreateVendors from '../pages/vendors/CreateVendors';
import PurchaseOrder from '../pages/purchaseOrder/PurchaseOrder';
import PurchaseReceived from '../pages/PurchaseRecieved/PurchaseReceived';
import CreatePurchaseReceive from '../pages/PurchaseRecieved/CreatePurchaseReceive';
import PurchaseBills from '../pages/purchasebills/PurchaseBills';
import PurchaseBillDetails from '../pages/purchasebills/PurchaseBillDetails';
import CreditNote from '../pages/creditNote/CreditNote';
import CreditNoteDetails from '../pages/creditNote/CreditNoteDetails';
import CreateCreditNote from '../pages/creditNote/CreateCreditNote';
import PaymentMade from '../pages/paymentMade/PaymentMade';
import PaymentMadeDetails from '../pages/paymentMade/PaymentMadeDetails';
import CreatePaymentMade from '../pages/paymentMade/CreatePaymentMade';
import CreatePurchaseBill from '../pages/purchasebills/CreatePurchaseBill';
import PurchaseOrderSendEmails from '../pages/purchaseOrder/PurchaseOrderSendEmails';
import PurchaseOrderDetails from '../pages/purchaseOrder/PurchaseOrderDetails';
import PurchaseReceiveDetails from '../pages/PurchaseRecieved/PurchaseReceiveDetails';
import CreatePurchaseOrder from '../pages/purchaseOrder/CreatePurchaseOrder';
import PurchaseReceiveSendEmail from '../pages/PurchaseRecieved/PurchaseReceiveSendEmail';
import Customers from '../pages/v2/sales/customers/customers';
import CustomersDetails from '../pages/v2/sales/customers/customerDetails';
import PurchaseMadeSendEmail from '../pages/paymentMade/PaymentMadeSendEmail';
import CreditNoteSendEmail from '../pages/creditNote/CreditNoteSendEmail';
import CreateCustomer from '../pages/v2/sales/customers/createCustomer';
import Doctors from '../pages/v2/sales/doctors/doctors';
import CreateDoctor from '../pages/v2/sales/doctors/createDoctor';
import DoctorDetails from '../pages/v2/sales/doctors/doctorDetails';
import Invoice from '../pages/v2/sales/invoice/invoice';
import CreateInvoice from '../pages/v2/sales/invoice/createInvoice';
import InvoiceDetails from '../pages/v2/sales/invoice/invoiceDetails';
import InvoiceSendEmails from '../pages/v2/sales/invoice/components/invoiceSendEmails';
import InvoiceSharedLinkPdfView from '../pages/v2/sales/invoice/invoiceDetails/shareLink/invoiceSharedLinkPdfView';
import PaymentReceived from '../pages/v2/sales/paymentReceieved';
import CreatePaymentReceived from '../pages/v2/sales/paymentReceieved/createPaymentReceieved';
import PaymentReceivedDetails from '../pages/v2/sales/paymentReceieved/paymentReceivedDetails';
import PaymentReceivedSendEmail from '../pages/v2/sales/paymentReceieved/components/paymentRecievedSendEmail';
import SalesReturn from '../pages/v2/sales/salesReturn';
import CreateSalesReturn from '../pages/v2/sales/salesReturn/createSalesReturn';
import SalesReturnDetails from '../pages/v2/sales/salesReturn/salesReturnDetails';
import SalesReturnSendEmail from '../pages/v2/sales/salesReturn/components/salesReturnSendEmail';
import SalesCreditNote from '../pages/v2/sales/credit_note';
import SalesCreateCreditNote from '../pages/v2/sales/credit_note/createCreditNote';
import SalesCreditNoteDetails from '../pages/v2/sales/credit_note/credit_note_details';
import SalesCreditNoteSendEmail from '../pages/v2/sales/credit_note/components/creditNoteSendEmail';
import Settings from '../pages/v2/settings';
import Reports from '../pages/v2/reports';
import SendEmailReport from '../pages/v2/reports/components/sendEmailReport';

export const Approuter = createBrowserRouter([
	{
		path: '/',
		element: <Login />,
	},
	{
		path: `/forgotPassword`,
		element: <ForgotPassword />,
	},
	{
		path: '/signup',
		element: <Signup />,
	},
	{
		path: '/createNewPassword',
		element: <CreateNewPassword />,
	},
	{
		path: '/otpVerify/*',
		element: <OTPVerify />,
	},
	{
		path: '/organizationDetail',
		element: <OrganizationDetail />,
	},
	{
		path: '/sales/invoices/share/:id?',
		element: <InvoiceSharedLinkPdfView />,
	},
	{
		path: '/user/:suburl/*',
		element: (
			<PrivateRoute>
				<Layout />
			</PrivateRoute>
		),
		children: [
			{
				path: `home`,
				element: <Dashboard />,
			},
			{
				path: 'product/:id?',
				element: <ProductDetails />,
			},
			{
				path: 'product-create/:id?',
				element: <CreateProduct />,
			},
			{
				path: 'group',
				element: <ProductGroup />,
			},
			{
				path: 'group-details/:id',
				element: <GroupDetails />,
			},
			{
				path: 'inventory-adjustment-crete/:id?',
				element: <Adjustment />,
			},
			{
				path: 'inventory-adjustment',
				element: <InventoryAdjustment />,
			},
			{
				path: 'vendor',
				element: <Vendors />,
			},
			{
				path: 'vendor-create/:id?',
				element: <CreateVendors />,
			},

			{
				path: 'purchases-order',
				element: <PurchaseOrder />,
			},
			{
				path: 'purchases-order-details/:id',
				element: <PurchaseOrderDetails />,
			},

			{
				path: 'purchases-order-create/:id?',
				element: <CreatePurchaseOrder />,
			},
			{
				path: 'purchases-order-edit/:id?',
				element: <CreatePurchaseOrder />,
			},
			{
				path: 'purchases-order-send-emails/:id',
				element: <PurchaseOrderSendEmails />,
			},
			{
				path: 'purchases-receive-send-emails/:id',
				element: <PurchaseReceiveSendEmail />,
			},
			{
				path: 'credit-note-send-emails/:id',
				element: <CreditNoteSendEmail />,
			},
			{
				path: 'payment-made-send-emails/:id',
				element: <PurchaseMadeSendEmail />,
			},

			{
				path: 'purchases-receive',
				element: <PurchaseReceived />,
			},
			{
				path: 'purchases-receive-details/:id?',
				element: <PurchaseReceiveDetails />,
			},
			{
				path: 'purchases-receive-create/:id?',
				element: <CreatePurchaseReceive />,
			},

			{
				path: 'purchases-bills',
				element: <PurchaseBills />,
			},
			{
				path: 'purchases-bills-details/:id?',
				element: <PurchaseBillDetails />,
			},
			{
				path: 'purchases-bills-create/:id?',
				element: <CreatePurchaseBill />,
			},

			{
				path: 'payment-made',
				element: <PaymentMade />,
			},
			{
				path: 'payment-made-details/:id?',
				element: <PaymentMadeDetails />,
			},
			{
				path: 'payment-made-create/:id?',
				element: <CreatePaymentMade />,
			},

			{
				path: 'credit-note',
				element: <CreditNote />,
			},
			{
				path: 'credit-note-details/:id?',
				element: <CreditNoteDetails />,
			},
			{
				path: 'credit-note-create/:id?',
				element: <CreateCreditNote />,
			},
			{
				path: 'customers',
				element: <Customers />,
			},

			{
				path: 'customers-create/:id?',
				element: <CreateCustomer />,
			},
			{
				path: 'customers-details/:id?',
				element: <CustomersDetails />,
			},

			{
				path: 'doctors',
				element: <Doctors />,
			},
			{
				path: 'doctors-create/:id?',
				element: <CreateDoctor />,
			},
			{
				path: 'doctors-details/:id?',
				element: <DoctorDetails />,
			},
			{
				path: 'invoices',
				element: <Invoice />,
			},
			{
				path: 'invoices-create/:id?',
				element: <CreateInvoice />,
			},
			{
				path: 'invoice-send-emails/:id',
				element: <InvoiceSendEmails />,
			},
			{
				path: 'invoices-details/:id?',
				element: <InvoiceDetails />,
			},
			{
				path: 'payments-received',
				element: <PaymentReceived />,
			},
			{
				path: 'payments-received-create/:id?',
				element: <CreatePaymentReceived />,
			},
			{
				path: 'payments-received-details/:id?',
				element: <PaymentReceivedDetails />,
			},
			{
				path: 'payments-received-send-emails/:id',
				element: <PaymentReceivedSendEmail />,
			},
			{
				path: 'sales-return',
				element: <SalesReturn />,
			},
			{
				path: 'sales-return-create/:id?',
				element: <CreateSalesReturn />,
			},

			{
				path: 'sales-return-details/:id?',
				element: <SalesReturnDetails />,
			},
			{
				path: 'sales-return-send-emails/:id',
				element: <SalesReturnSendEmail />,
			},
			{
				path: 'sales/credit-note',
				element: <SalesCreditNote />,
			},
			{
				path: 'sales/credit-note-create/:id?',
				element: <SalesCreateCreditNote />,
			},
			{
				path: 'sales/credit-note-details/:id?',
				element: <SalesCreditNoteDetails />,
			},
			{
				path: 'sales/credit-note-send-emails/:id',
				element: <SalesCreditNoteSendEmail />,
			},
			{
				path: 'settings/:type?',
				element: <Settings />,
			},
			{
				path: 'reports/:type?',
				element: <Reports />,
			},
			{
				path: 'reports/send-emails/:type?',
				element: <SendEmailReport />,
			},
			// ...[
			// 	process.env.REACT_APP_ENVIRONMENT === 'development'
			// 		? {
			// 				path: 'developer',
			// 				element: <Developer />,
			// 			}
			// 		: {},
			// ],
			{
				path: '*',
				element: <NotFound />,
			},
		],
	},
]);
